import preparar from '@/assets/fases/preparar.jpg';
import atuar from '@/assets/fases/atuar.jpg';
import aprender from '@/assets/fases/aprender.jpg';
import { curso } from '@curso/content/curso';

/**
 * As tres etapas do curso, na ordem em que o participante vive.
 *
 * Texto do roteiro de 19/10. Os rotulos PREPARAR, DISCUTIR e EXPERIMENTAR
 * substituem a descricao por formato ("doze videoaulas", "dois webinars") que
 * existia antes: dizem o que a pessoa faz, nao o que ela recebe.
 */
export const etapas: { titulo: string; texto: string }[] = [
  {
    titulo: 'Preparar',
    texto: `${curso.videoaulas}\u00a0videoaulas, no seu tempo. Construa a base antes da experiência presencial, com aulas objetivas de aproximadamente ${curso.duracaoAula} e materiais de apoio. Você chega à simulação já familiarizado com os conceitos e ferramentas que serão colocados em prática. Acesso ao conteúdo por ${curso.acesso}.`,
  },
  {
    titulo: 'Discutir',
    texto:
      'Dois encontros ao vivo. Conecte teoria e prática pela discussão de situações, aprofundamento dos conceitos e troca de experiências com facilitadores e participantes. Entre os encontros, um fórum mantém a discussão ativa.',
  },
  {
    titulo: 'Experimentar',
    texto: `${curso.horasPresenciais}\u00a0horas de experiência prática presencial. Um fim de semana para transformar conceito em comportamento. Em pequenos grupos, os participantes enfrentam cenários desenhados para explorar comunicação, liderança, consciência situacional, suporte mútuo e tomada de decisão sob pressão. A experiência acontece no cenário. O aprendizado se consolida no debriefing.`,
  },
];

/**
 * As tres fases de um cenario, na escala do conceito.
 *
 * Aparece duas vezes: com foto em "Como funciona" e sem foto em "O fim de
 * semana". Ate 20/10 o fim de semana tinha uma lista propria (briefing,
 * atuacao, debriefing, intervalo); a revisao da Kelly trocou pelas mesmas tres
 * fases, para a pagina nao descrever o mesmo arco com duas palavras diferentes.
 */
export const fasesDoCenario: {
  titulo: string;
  texto: string;
  imagem?: string;
  alt?: string;
}[] = [
  {
    titulo: 'Preparar',
    texto: 'A equipe recebe o contexto e as informações disponíveis para iniciar o cenário.',
    imagem: preparar,
    alt: 'Cockpit e sala de emergência lado a lado, os dois conferindo uma lista antes de começar.',
  },
  {
    titulo: 'Atuar',
    texto:
      'O cenário evolui em tempo real. Quem participa precisa comunicar, priorizar e decidir com os recursos disponíveis. Quem observa acompanha comportamentos e ferramentas previamente definidos.',
    imagem: atuar,
    alt: 'Cockpit e sala de emergência lado a lado, as duas equipes trabalhando sob pressão.',
  },
  {
    titulo: 'Aprender',
    texto:
      'Imediatamente depois, participantes e facilitadores analisam juntos o que aconteceu: decisões, comunicação, coordenação da equipe e oportunidades de melhoria.',
    imagem: aprender,
    alt: 'Cockpit vazio e corredor de hospital, as duas equipes conversando depois que tudo terminou.',
  },
];

/** A frase que fecha o arco. Texto da Kelly, 20/10. */
export const sentidoDoDebriefing =
  'A análise se concentra em compreender como a equipe funciona sob pressão e quais comportamentos podem ser\u00a0aprimorados.';
